import Vue from 'vue'
import VueRouter from 'vue-router'
import homePage from '@/views/homePage.vue'
import playMovie from '@/views/playMovie.vue'
Vue.use(VueRouter)

const routes = [
  // { path: '/', redirect: 'home' },
  { path: '/home', component: homePage },
  { path: '/play', component: playMovie }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: 'exact-active',
  linkActiveClass: 'active'
})

export default router
